import { render, staticRenderFns } from "./sessionPanel.vue?vue&type=template&id=2a380973&scoped=true"
import script from "./sessionPanel.vue?vue&type=script&lang=js"
export * from "./sessionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a380973",
  null
  
)

export default component.exports